import axios from "./axiosInstance";

const newsletterAPI = {
  subscribe: (body) => axios.post("newsletter-subscriptions/subscribe", body),
  unsubscribe: (body) => axios.post("newsletter-subscriptions/unsubscribe", body),
};

export default newsletterAPI;